<template>
    <auth-button
      :class="{'o-like--unlike': isLiked}"
      @click="toggleLike"
      class="o-playlist__button o-like"
     >
      <SvgIcon icon="heart" class="o-playlist__icon" aria-hidden="true" />
    </auth-button>
</template>

<script>
export default {
  name: 'Like',
  props: [
    'selectorCode',
  ],
  computed: {
    isLiked() {
      return this.$store.getters['likes/getLikeForTrack'](this.selectorCode);
    },
  },
  methods: {
    toggleLike() {
      this.$store.dispatch('likes/toggleForTrack', this.selectorCode);
    },
  },
};
</script>
